<template>
  <div
    class="main-conent main-conent-maxheight main-content-rows page-dashboard"
  >
    <div class="main-content-cols">
      <side-menu
        v-if="teles.length > 1"
        :menus="menus"
        :actived="activedDeviceIndex"
        @change="deviceChange"
      ></side-menu>

      <div class="main-content-cols__body">
        <el-row :gutter="20">
          <el-col>
            <gauge
              :device-id="device.id"
              :loading="loading"
              :warnings="warnings"
              @active-insect="setInsect"
            ></gauge>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="6" class="col-maxheight">
            <el-card shadow="never" class="flatten-card">
              <div slot="header" class="clearfix">
                <span>虫害/种类比例情况(近15天)</span>
              </div>
              <pie
                :loading="loading"
                :data="insectCategories"
                :not-merge="notMergeChartOpt"
              ></pie>
            </el-card>
            <el-card shadow="never" class="flatten-card">
              <div slot="header" class="clearfix">
                <span>虫害/终端比例情况(近15天)</span>
              </div>
              <funnel :loading="loading" :data="deviceData"></funnel>
            </el-card>
          </el-col>
          <el-col :span="18" class="col-maxheight">
            <el-card shadow="never" class="flatten-card">
              <div slot="header" class="clearfix">
                <span>虫害近期变化趋势</span>
              </div>
              <trend
                :loading="loading"
                :not-merge="notMergeChartOpt"
                :actived="insect"
                :device-id="device.id"
                :trends="insectTrends"
                :trends-today="trendsToday"
              ></trend>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { getWarnings, getTrend } from '@/service/telemetry'
import SideMenu from '@/components/MainSideMenu'
import Gauge from './components/gauge'
import Pie from './components/pie'
import Funnel from './components/funnel'
import Trend from './components/trend'

export default {
  components: { Gauge, SideMenu, Pie, Funnel, Trend },
  data() {
    return {
      loading: true,
      loadingToday: false,
      menus: [],
      warnings: [],
      categoryData: [],
      trends: [],
      deviceData: [],
      trendsToday: [],
      activedDeviceIndex: 0, // 测报灯
      insect: null,
      notMergeChartOpt: false // 图表是否合并设置项，选中的设备昆虫种类改变时变更
    }
  },
  computed: {
    device() {
      return this.teles[this.activedDeviceIndex]
    },
    insects() {
      return this.warnings
        .filter(w => w.deviceId === this.device.id)
        .map(w => ({ name: w.category, id: w.categoryId }))
    },
    insectTrends() {
      return this.trends.filter(
        t => this.insects.findIndex(i => i.id === t.id) > -1
      )
    },
    insectCategories() {
      let deviceId = this.device.id
      return this.insectTrends.map(t => {
        const sum = t.data.reduce((sum, cur) => {
          let device = cur.devices.find(d => d.id === deviceId)
          return device ? sum + device.qty : 0
        }, 0)
        return { category: t.category, qty: sum }
      })
    }
  },
  mounted() {
    this.menus = this.teles.map(m => ({ title: m.name.replace('PBZ01D-', '') }))
    this.getData()
    this.getTrendsToday(this.device.id)
  },
  methods: {
    async getData() {
      this.loading = true

      const { data } = await getWarnings(this.companyId)
      this.warnings = data.warnings
      this.trends = data.trends
      this.deviceData = data.devices.filter(o => o.qty > 0)

      this.loading = false
    },
    async getTrendsToday(id) {
      this.loadingToday = true
      const { data } = await getTrend(id)
      this.trendsToday = data
      this.loadingToday = false
    },
    deviceChange(index) {
      let oldInsects = this.insects
      this.activedDeviceIndex = index
      this.onDeviceChange(oldInsects)
      this.$nextTick(() => {
        this.getTrendsToday(this.device.id)
      })
    },
    setInsect(name) {
      this.insect = name
    },
    //
    onDeviceChange(oldInsects) {
      if (oldInsects.length === this.insects.length) {
        const isEqual = oldInsects.every(i => {
          let index = this.insects.findIndex(ii => ii.id === i.id)
          return index > -1
        })
        this.notMergeChartOpt = !isEqual
      } else {
        this.notMergeChartOpt = true
      }
    }
  }
}
</script>

<style lang="scss">
.page-dashboard {
  .main-content-cols__body {
    overflow-x: hidden;
    overflow-y: auto;
  }
}
.col-maxheight {
  height: calc(100%);
  display: flex;
  flex-direction: column;
}
.flatten-card {
  flex: 1;
  box-sizing: border-box;
  font-size: 14px;
  min-height: 240px;
  .chart-wrap {
    height: 100%;
  }
  .no-data {
    height: 100%;
  }
}
.flatten-card:not(:last-child) {
  margin-bottom: 20px;
}
.flatten-card .el-card__body {
  height: calc(100% - 53px);
  padding: 0;
}
</style>
